import {
  SIGNIN,
  SIGNINSECONDARY,
  AUTHENTICATED,
  MULTIPROJECTPROMPT,
  SECONDARY_AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNUP,
  FORGET,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  SIGNIN_WITH_GOOGLE,
  SIGNIN_WITH_OPENID,
  SIGNIN_WITH_CUSTOM_TOKEN,
  SIGNIN_WITH_GOOGLE_AUTHENTICATED,
  SIGNIN_WITH_FACEBOOK,
  SIGNIN_WITH_FACEBOOK_AUTHENTICATED
} from '../constants/Auth';

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user
  }
};

export const signInSecondary = (connectionData) => {
  return {
    type: SIGNINSECONDARY,
    payload: connectionData
  }
};

export const authenticated = (token) => {
  return {
    type: AUTHENTICATED,
    token
  }
};

export const multiprojectPrompt = (payload) => {
  return {
    type: MULTIPROJECTPROMPT,
    payload
  }
};

export const secondaryAuthenticated = (secondaryApp) => {
  return {
    type: SECONDARY_AUTHENTICATED,
    secondaryApp
  }
};

export const forget = (user) => {
  return {
    type: FORGET,
    payload: user
  }
};

export const signOut = () => {
  return {
    type: SIGNOUT
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  }
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user
  };
};

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token
  };
};

export const signInWithGoogle = () => {
  return {
    type: SIGNIN_WITH_GOOGLE
  };
};

export const signInWithOpenId = () => {
  return {
    type: SIGNIN_WITH_OPENID
  };
};

export const signInWithCustomToken = (token) => {
  return {
    type: SIGNIN_WITH_CUSTOM_TOKEN,
    payload: { token }
  };
};

export const signInWithGoogleAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    token
  };
};

export const signInWithFacebook = () => {
  return {
    type: SIGNIN_WITH_FACEBOOK
  };
};

export const signInWithFacebookAuthenticated = (token) => {
  return {
    type: SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    token
  };
};

export const showAuthMessage = (message, messageType) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message,
    messageType
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};
